import { IconPack, library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

export default function registerIcons() {
  library.add(far as IconPack, fas as IconPack);
}
